import { RQParam, RQService, RQApp }                         from '../RQuery/RQuery';
import { Injectable, ApplicationRef }                        from '@angular/core';
import { IonicErrorHandler, NavController, AlertController } from 'ionic-angular';
import { Platform, App }                                     from 'ionic-angular';
import { ExceptionPage }                                     from '../pages/exception/exception';

export class dmException {
    Message:            string;
    StackTrace:         string;
    LogAttemptFinished: boolean;

    constructor(
         pMessage:    string
        ,pStackTrace: string
    ) {
        this.Message            = (pMessage)    ? pMessage    : '(no message)';
        this.StackTrace         = (pStackTrace) ? pStackTrace : '(no call stack)';
        this.LogAttemptFinished = false;
    }
}

@Injectable()
export class UnhandledExceptionHandler extends IonicErrorHandler {
    RootNav:               NavController;
    Application:           App;
    ApplicationRef:        ApplicationRef;
    NavInitialised:        boolean;
    MLInitialised:         boolean;
    ExceptionsThrown:      boolean;
    OnExceptionPage:       boolean;
    PageLoaded:            boolean;
    InRemoteLogAttempt:    boolean;
    FoundLogFailure:       boolean;

    FirstPage:             any;
    NotifyAppOfCondition:  (pIsException: boolean, pIsNetworkOrSession: boolean) => void;
    SessionExpiryAction:   () => void;

    Exceptions:            dmException[];

    ExceptionParams        = RQParam.OtaRegisterWebExceptionParams();

    constructor(public alertCtrl: AlertController, public platform: Platform) {
        super();

        console.log('initialising error service');

        this.NavInitialised       = false;
        this.MLInitialised        = false;
        this.ExceptionsThrown     = false;
        this.OnExceptionPage      = false;
        this.PageLoaded           = false;
        this.InRemoteLogAttempt   = false;
        this.FoundLogFailure      = false;
        this.Exceptions           = [];

        this.NotifyAppOfCondition = (pIsException: boolean, pIsNetworkOrSession: boolean) => { };
        this.SessionExpiryAction  = () => { };

        RQApp.HandleTimeout       = (serviceName: string ,commandName: string)  => {
            console.log('Timeout in RQuery call');

            this.NotifyAppOfCondition(false, true);

            if (this.FoundLogFailure) { return; }

            if (this.InRemoteLogAttempt) {
                this.FoundLogFailure    = true;
                this.InRemoteLogAttempt = false;

                this.Exceptions.push(
                    new dmException(
                         'Sending error report failed, slow or no network.'
                        ,'(no call stack)'
                    )
                );

                if (
                    (this.NavInitialised)
                &&  (this.RootNav)
                &&  (this.Application)
                &&  (this.PageLoaded)
                ) {
                    this.ApplicationRef.tick();
                }
            }

            if (!this.NavInitialised) {
                throw new Error('Slow or non-functional network connection in startup');
            }

            let alert = this.alertCtrl.create({
                 title:   'Network Timeout'
                ,message: 'Slow or non-functional network connection detected, '
                        + 'restart or quit the application.'
                ,buttons: [
                    {
                         text:    'Restart'
                        ,handler: () => {
                            this.RootNav.setRoot(this.FirstPage);
                        }
                    }
                ]
                ,enableBackdropDismiss: false
            });

            alert.present();
        };

        RQApp.HandleNetworkError  = (serviceName: string ,commandName: string)  => {
            console.log('Network Error in RQuery call');

            this.NotifyAppOfCondition(false, true);

            if (this.FoundLogFailure) { return; }

            if (this.InRemoteLogAttempt) {
                this.FoundLogFailure    = true;
                this.InRemoteLogAttempt = false;

                this.Exceptions.push(
                    new dmException(
                         'Sending error report failed, bad or no network.'
                        ,'(no call stack)'
                    )
                );

                if (
                    (this.NavInitialised)
                &&  (this.RootNav)
                &&  (this.Application)
                &&  (this.PageLoaded)
                ) {
                    this.ApplicationRef.tick();
                }
            }

            if (!this.NavInitialised) {
                throw new Error('No or faulty network connection in startup');
            }

            let alert = this.alertCtrl.create({
                 title:   'Network Error'
                ,message: 'No or faulty network connection detected, '
                        + 'restart the application.'
                ,buttons: [
                    {
                         text:    'Restart'
                        ,handler: () => {
                            this.RootNav.setRoot(this.FirstPage);
                        }
                    }
                ]
                ,enableBackdropDismiss: false
            });

            alert.present();
        };

        RQApp.HandleSessionExpiry = () => {
            console.log('Session Expiry in RQuery call');

            this.NotifyAppOfCondition(false, true);

            if (!this.NavInitialised) {
                throw new Error('Session expiry in startup');
            }

            this.SessionExpiryAction();

            this.RootNav.setRoot(this.FirstPage);
        };

        RQApp.ShowDialog          = (message: string ,callback: () => void) => {
            if (this.FoundLogFailure) { return; }

            if (this.InRemoteLogAttempt) {
                this.FoundLogFailure    = true;
                this.InRemoteLogAttempt = false;

                this.Exceptions.push(
                    new dmException(
                         'Sending error report failed due to remote logging error.'
                        ,'(no call stack)'
                    )
                );

                if (
                    (this.NavInitialised)
                &&  (this.RootNav)
                &&  (this.Application)
                &&  (this.PageLoaded)
                ) {
                    this.ApplicationRef.tick();
                }
            }

            if (!this.NavInitialised) {
                throw new Error('Remote query error during startup');
            }

            let alert = this.alertCtrl.create({
                 title:   'Error'
                ,message: message
                ,buttons: [
                    {
                         text:    'OK'
                        ,handler: () => {
                            if (callback) { callback(); }
                        }
                    }
                ]
                ,enableBackdropDismiss: false
            });

            alert.present();
        };
    }

    handleError(error) {
        /*
            Note: ion-autocomplete component throws mystery empty exceptions when
            network is absent. We swallow them here to allow recovery, which is not
            ideal for robustness, as other anomalous excpetion conditions could be
            swallowed.
        */

        if (!error) { return; }

        /*
            Note: we swallow (removeView not found/no views in stack) exceptions,
            as loadingCtrl is buggy and generates spurious ones.
        */

        if (
            error
        &&  error.message
        &&  error.message.endsWith('removeView was not found')
        ) {
            console.log('swallowed spurious loading tear-down exception');

            return;
        }

        if (!this.ExceptionsThrown) { this.ExceptionsThrown = true; }

        this.NotifyAppOfCondition(true, false);

        let exception: dmException = (error)
            ? new dmException(error.message, error.stack)
            : new dmException('no error object', 'no stack');

        this.Exceptions.push(exception);

        console.log('caught exception...');
        console.log('message:');
        console.log(exception.Message);
        console.log('call stack:');
        console.log(exception.StackTrace);

        if (exception.Message.substr(0, 12) == 'RQLogFailure') {
            this.FoundLogFailure = true;
        }

        if (
            (this.NavInitialised)
        &&  (this.RootNav)
        &&  (this.Application)
        ) {
            if (!this.OnExceptionPage) {
                this.OnExceptionPage = true;

                this.RootNav.setRoot(
                    ExceptionPage, { exHandler: this }
                );
            } else {
                if (
                    (this.PageLoaded)
                && !(this.InRemoteLogAttempt)
                && !(this.FoundLogFailure)
                ) {
                    this.RemoteLogException(exception, () => { return; });
                }

                this.ApplicationRef.tick();
            }
        } else {
            this.RemoteLogException(exception, () => { return; });
        }
    }

    public InitialiseNav(
         pRootNav:              NavController
        ,pApplicationRef:       ApplicationRef
        ,pApplication:          App
        ,pFirstPage:            any
        ,pNotifyAppOfCondition: (pIsException: boolean, pIsNetworkOrSession: boolean) => void
        ,pSessionExpiryAction?: () => void
    ): void {
        if (this.NavInitialised) { return; }

        if (pRootNav) {
            this.NavInitialised       = true;
            this.RootNav              = pRootNav;
            this.Application          = pApplication;
            this.ApplicationRef       = pApplicationRef;
            this.FirstPage            = pFirstPage;
            this.NotifyAppOfCondition = pNotifyAppOfCondition;

            if (pSessionExpiryAction) { this.SessionExpiryAction = pSessionExpiryAction; }

            if (
                (this.ExceptionsThrown)
            && !(this.OnExceptionPage)
            ) {
                this.OnExceptionPage = true;

                this.NotifyAppOfCondition(true, false);

                this.RootNav.setRoot(
                    ExceptionPage, { exHandler: this }
                );
            }
        }
    }

    private randomIdentifier(): string {
        let symbols = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

        return Array.apply(null, Array(8)).map(function () {
            return symbols.charAt(Math.floor(Math.random() * symbols.length));
        }).join('');
    }

    public RemoteLogException(pException: dmException, pAction: () => void): void {
        this.NotifyAppOfCondition(true, false);

        if (this.InRemoteLogAttempt || this.FoundLogFailure) {
            pAction();

            if (
                (this.NavInitialised)
            &&  (this.RootNav)
            &&  (this.Application)
            &&  (this.PageLoaded)
            ) {
                this.ApplicationRef.tick();
            }

            return;
        }

        this.InRemoteLogAttempt            = true;

        this.ExceptionParams.RequestID     = 'js-client: ' + this.randomIdentifier();
        this.ExceptionParams.URI           = (window && window.location && window.location.href)
            ? window.location.href
            : '(unknown)';
        this.ExceptionParams.IPAddress     = '(unknown)';
        this.ExceptionParams.UserAgent     = (navigator && navigator.userAgent)
            ? navigator.userAgent
            : '(unknown)';
        this.ExceptionParams.Referer       = '(none)';
        this.ExceptionParams.ExceptionText = pException.Message;
        this.ExceptionParams.StackTrace    = pException.StackTrace;
        this.ExceptionParams.Priority      = 5;

        RQService.Ota.RegisterWebException(this.ExceptionParams).then(result => {
            let response = result as any;

            if (!response.HasErrorOrException) { console.log('exception logged ok'); }

            pException.LogAttemptFinished = true;

            this.InRemoteLogAttempt       = false;

            if (
                (this.NavInitialised)
            &&  (this.RootNav)
            &&  (this.Application)
            &&  (this.PageLoaded)
            ) {
                pAction();
            }
        });
    }

    public SetPageLoaded(): void {
        this.PageLoaded = true;
    }

    public SetMLInitialised(): void {
        this.MLInitialised = true;
    }

    public CheckForLoggingFailure(): boolean {
        return this.FoundLogFailure;
    }
}



// WEBPACK FOOTER //
// ./src/services/UnhandledExceptions.ts